import React from 'react';
import mockupFrame from '../../resource/image/mockup-imac-video-frame.png';

/**
 * VideoMockup Component
 * iMac 목업 프레임 내부에 비디오를 재생하는 컴포넌트입니다.
 */
const VideoMockup = ({ videoSrc, className = '', videoProps = {} }) => {
  return (
    <div className={`relative w-full max-w-[1200px] mx-auto ${className}`}>
      {/* iMac Mockup Frame */}
      <img
        src={mockupFrame}
        alt="iMac Mockup Frame"
        className="w-full h-auto block relative z-0 pointer-events-none"
      />

      {/* Video Overlay Area */}
      <div
        className="absolute z-10"
        style={{
          top: '1.5%',      // 목업 이미지의 스크린 시작 상단 위치 (%)
          left: '1%',       // 목업 이미지의 스크린 시작 좌측 위치 (%)
          width: '98%',     // 목업 이미지의 스크린 너비 비율 (%)
        }}
      >
        {videoSrc && (
          <video
            autoPlay
            muted
            loop
            playsInline
            controls={false}
            className="w-full h-full object-contain bg-black"
            {...videoProps}
          >
            <source src={videoSrc} type="video/webm" />
            <source src={videoSrc.replace('.webm', '.mp4')} type="video/mp4" />
          </video>
        )}
      </div>
    </div>
  );
};

export default VideoMockup;
